import store from '..';

const state = {
    parentComponent:        'unassigned',
    startIndexCPU:          "not assigned",
    startIndexMb:           0,
    startIndexRAM:          0,
    startIndexStorage:      0,
    startIndexGPU:          0,
    startIndexPSU:          0,
    startIndexCase:         0,
    startIndexAccessories:  0,
};

const getters = {
    //Getting parent component name from parentComponent variable
    getParentComponent: (state) => state.parentComponent,

    //Getting starting slide index, respectively to name of the component
    getStartIndex: (state) => {
        switch (store.getters.lastRoute.replace(/\\|\/builder\//g, '')) {
            case ('cpu'):
                console.log('assigning cpu start index')
                console.log('start cpu index is '+state.startIndexCPU)
                return state.startIndexCPU
            case ('motherboard'):
                console.log('assigning MB start index')
                console.log('start MB index is '+state.startIndexMb)
                return state.startIndexMb
            case ('ram'):
                return state.startIndexRAM
            case ('storage'):
                return state.startIndexStorage
            case ('gpu'):
                return state.startIndexGPU
            case ('psu'):
                return state.startIndexPSU
            case ('case'):
                return state.startIndexCase
            case ('accessories'):
                return state.startIndexCase
            default:
                return 0
        }
    }
};
const actions = {
    async setParentComponent({ commit }, parentComponent) {
        commit('newParentComponent', parentComponent)
    },
    async setStartIndex({ commit }, startIndex) {
        commit('newIndex', startIndex)
    }
};

const mutations = {
    newParentComponent: (state, parentComponent) => {
        state.parentComponent = parentComponent;
    },
    //Assigning new start index
    newIndex: (state, startIndex) => {
        switch (store.getters.lastRoute.replace(/\\|\/builder\//g, '')) {
            case ('cpu'):
                state.startIndexCPU = startIndex
                break;
            case ('motherboard'):
                state.startIndexMB = startIndex
                break;
            case ('ram'):
                state.startIndexRAM
                break;
            case ('storage'):
                state.startIndexStorage
                break;
            case ('gpu'):
                state.startIndexGPU
                break;
            case ('psu'):
                state.startIndexPSU
                break;
            case ('case'):
                state.startIndexCase
                break;
            case ('accessories'):
                state.startIndexCase
                break;
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}